module.exports = __webpack_public_path__ + "static/pop2-108592da3b6adfe50b933a21fcb85796.jpg";